// import React, { useState, useEffect } from "react";
// import { Input } from "../../../common/commonIndex";

// const InsuranceCardInfo = ({ nestedQuestion, formData, handleSetData }) => {
//     const [formFields, setFormFields] = useState({
//         id: '',
//         group: '',
//         bin: '',
//         pcn: '',
//     });

//     const [validFields, setValidFields] = useState({
//         id: false,
//         group: false,
//         bin: false,
//         pcn: false,
//     });

//     // Field validation
//     const validateField = (value) => typeof value === 'string' && value.trim() !== '';

//     // Populate initial form fields from `formData`
//     useEffect(() => {
//         // if (formData && formData?.answer) {
//         //     setFormFields({
//         //         id: formData?.answer?.find((item) => item?.question === 'ID')?.answer || '',
//         //         group: formData?.answer?.find((item) => item?.question === 'Group')?.answer || '',
//         //         bin: formData?.answer?.find((item) => item?.question === 'Bin')?.answer || '',
//         //         pcn: formData?.answer?.find((item) => item?.question === 'PCN')?.answer || '',
//         //     });
//         // }

//         if (formData && formData?.answer) {
//             const initialFields = {
//                 id: formData.answer.find(item => item.question === "ID")?.answer || '',
//                 group: formData.answer.find(item => item.question === "Group")?.answer || '',
//                 bin: formData.answer.find(item => item.question === "Bin")?.answer || '',
//                 pcn: formData.answer.find(item => item.question === "PCN")?.answer || '',
//             };

//             setFormFields(initialFields);

//             setValidFields({
//                 id: validateField(initialFields.id),
//                 group: validateField(initialFields.group),
//                 bin: validateField(initialFields.bin),
//                 pcn: validateField(initialFields.pcn),
//             });
//         }

//     }, [formData]);

//     // Update field values and validation state
//     const handleFieldChange = (field, value) => {
//         setFormFields((prev) => ({ ...prev, [field]: value }));
//         setValidFields((prev) => ({ ...prev, [field]: validateField(value) }));

//         if (formData) {
//             const existingAnswer = formData?.answer?.find(item => item.question === field.charAt(0).toUpperCase() + field.slice(1));
//             if (existingAnswer) {
//                 existingAnswer.questionId = !existingAnswer?.questionId ? nestedQuestion.id : existingAnswer.questionId;
//                 existingAnswer.answer = value;
//                 existingAnswer.answerId = value;
//                 existingAnswer.questionerType = nestedQuestion.questionType; // Replace with the relevant type if needed
//                 existingAnswer.userIdDocument = null;
//                 existingAnswer.none = null;
//                 existingAnswer.question = nestedQuestion.question;
//             } else {
//                 if(!formData?.answer || formData?.answer === undefined){
//                     formData.answer = []
//                 }
//                 formData?.answer?.push({
//                     questionId: nestedQuestion?.id, // Replace with the relevant ID if needed
//                     answer: value,
//                     answerId: value,
//                     questionerType: nestedQuestion.questionType, // Replace with the relevant type if needed
//                     userIdDocument: null,
//                     none: null,
//                     question: field.charAt(0).toUpperCase() + field.slice(1),
//                 });
//             }
//         }

//         handleSetData && handleSetData(formData); // Notify parent about updated data
//     };

//     // Render individual input fields
//     const renderInputField = (fieldName, label) => (
//         <div key={fieldName} className={`input-group mb-3 ${validFields[fieldName] ? 'valid' : ''}`}>
//             <Input
//                 inputType="text"
//                 id={fieldName}
//                 inputPlaceholder=""
//                 className="form-control"
//                 required
//                 onChange={(e) => handleFieldChange(fieldName, e)}
//                 value={formFields[fieldName]}
//             />
//             <label htmlFor={fieldName} className={validFields[fieldName] ? 'is-active active' : 'active'}>
//                 {label}
//             </label>
//         </div>
//     );

//     return (
//         <div>
//             <form>
//                 {nestedQuestion?.question &&
//                     (() => {
//                         const questionType = nestedQuestion?.question?.toLowerCase();
//                         switch (questionType) {
//                             case 'id':
//                                 return renderInputField('id', 'ID #');
//                             case 'group':
//                                 return renderInputField('group', 'Group');
//                             case 'bin':
//                                 return renderInputField('bin', 'Bin #');
//                             case 'pcn':
//                                 return renderInputField('pcn', 'PCN');
//                             default:
//                                 return null;
//                         }
//                     })()}
//             </form>
//         </div>
//     );
// };

// export default InsuranceCardInfo;


import React, { useState, useEffect } from "react";
import { Input } from "../../../common/commonIndex";

const InsuranceCardInfo = ({ nestedQuestion, formData, handleSetData, setIsValid, validFields, setValidFields }) => {
    const [formFields, setFormFields] = useState({
        id: '',
        group: '',
        bin: '',
        pcn: '',
    });

    // const [validFields, setValidFields] = useState({
    //     id: false,
    //     group: false,
    //     bin: false,
    //     pcn: false,
    // });

    // Field validation
    const validateField = (value) => typeof value === 'string' && value.trim() !== '';

    // Populate initial form fields from `formData`
    useEffect(() => {
        if (formData?.answer) {
            const initialFields = {
                id: formData.answer.find(item => item?.question?.toLowerCase() === "id" || item.id === 5648 || item.fkQuestionId === 5648)?.answer || '',
                group: formData.answer.find(item => item?.question?.toLowerCase() === "group" || item.id === 5649 || item.fkQuestionId === 5649)?.answer || '',
                bin: formData.answer.find(item => item?.question?.toLowerCase() === "bin" || item.id === 5650 || item.fkQuestionId === 5650)?.answer || '',
                pcn: formData.answer.find(item => item?.question?.toLowerCase() === "pcn" || item.id === 5651 || item.fkQuestionId === 5651)?.answer || '',
            };

            setFormFields(initialFields);

            setValidFields({
                id: validateField(initialFields.id),
                group: validateField(initialFields.group),
                bin: validateField(initialFields.bin),
                pcn: validateField(initialFields.pcn),
            });
        }
    }, [formData]);

    // Update field values and validation state
    const handleFieldChange = (field, value) => {
        setFormFields((prev) => ({ ...prev, [field]: value }));
        setValidFields((prev) => ({ ...prev, [field]: validateField(value) }));
        if (formData) {
            const fieldLabel = field.charAt(0).toUpperCase() + field.slice(1);
            // Filter out entries for the same field that don't match the current value
            const existingAnswerIndex = formData.answer?.findIndex(item => item.question === nestedQuestion.question);
            if (existingAnswerIndex !== -1 && formData?.answer?.length > 0) {
                // Update existing entry
                formData.answer[existingAnswerIndex].answer = value;
                formData.answer[existingAnswerIndex].fkAnswerIds = value;
            } else {
                // Add new entry if not found
                if (!formData.answer) formData.answer = [];
                formData.answer.push({
                    fkQuestionId: nestedQuestion?.id, // Replace with the relevant ID if needed
                    answer: value,
                    fkAnswerIds: value,
                    questionerType: nestedQuestion.questionType, // Replace with the relevant type if needed
                    question: nestedQuestion.question,
                });
            }
        }

        handleSetData && handleSetData(formData); // Notify parent about updated data
    };

    useEffect(() => {
        const findlength = formData?.answer?.filter(x => !x.answer || x.answer === '')?.length === 0;
        setIsValid(findlength);
    }, [handleFieldChange]);

    // Render individual input fields
    const renderInputField = (fieldName, label) => (
        <div key={fieldName} className={`input-group mb-3 ${validFields[fieldName] ? 'valid' : ''}`}>
            <Input
                inputType="text"
                id={fieldName}
                inputPlaceholder=""
                className="form-control"
                required
                onChange={(e) => handleFieldChange(fieldName, e)}
                value={formFields[fieldName]}
            />
            <label htmlFor={fieldName} className={validFields[fieldName] ? 'is-active active' : 'active'}>
                {label}
            </label>
        </div>
    );

    return (
        <div>
            <form>
                {nestedQuestion?.question &&
                    (() => {
                        const questionType = nestedQuestion?.question?.toLowerCase();
                        switch (questionType) {
                            case 'id':
                                return renderInputField('id', 'ID #');
                            case 'group':
                                return renderInputField('group', 'Group');
                            case 'bin':
                                return renderInputField('bin', 'BIN #');
                            case 'pcn':
                                return renderInputField('pcn', 'PCN');
                            default:
                                return null;
                        }
                    })()}
            </form>
        </div>
    );
};

export default InsuranceCardInfo;

